// main.tsx (or index.tsx)
import "leaflet/dist/leaflet.css"; // 1) Leaflet styles

import "./lib/geoman-shim";

import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App.tsx";
import { AuthProvider } from "./context/AuthContext";
import "./i18n";
import "./index.css";

// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(500 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize MSAL instance before rendering the app
msalInstance
  .initialize()
  .then(() => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <MsalProvider instance={msalInstance}>
            <AuthProvider>
              <Router>
                <App />
              </Router>
            </AuthProvider>
          </MsalProvider>
        </QueryClientProvider>
      </StrictMode>,
    );
  })
  .catch((error) => {
    console.error("MSAL initialization failed:", error);
    // Optionally render an error message to the user
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <div>MSAL Initialization Failed. Please contact support.</div>
      </StrictMode>,
    );
  });
